import { AxiosError } from 'axios'
import * as HttpStatus from 'http-status-codes'
import { memoize } from 'lodash'
import { ForbiddenError, NotFoundError, ServerError, UnauthorizedError } from 'utils-next/errors'

function getBrowserProcessEnv() {
  return process.env
}

export const networkErrorMapper = memoize((error: AxiosError) => {
  const { response: httpError } = error
  if (!httpError) {
    return error
  }

  switch (httpError.status) {
    case HttpStatus.UNAUTHORIZED:
      return new UnauthorizedError(httpError.data.message)
    case HttpStatus.NOT_FOUND:
      return new NotFoundError(httpError.data.message)
    case HttpStatus.FORBIDDEN:
      return new ForbiddenError(httpError.data.message)
    default: {
      return new ServerError(httpError.data.message)
    }
  }
})

export function generateApiRoot(getProcessEnv: () => NodeJS.ProcessEnv = getBrowserProcessEnv) {
  const envHost = getProcessEnv()?.REACT_APP_BACKEND_HOST
  const backendHost = envHost || 'https://staging-api.foundernest.com'

  return `${backendHost}/api/`
}

export function getAuthHeaders(token?: string) {
  const AUTH_HEADER = 'Authorization'
  return token ? { [AUTH_HEADER]: `Bearer ${token}` } : {}
}
